// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

interface CoverImageProps {
  width?: string | number;
  height?: string | number;
  src: string;
}

export default styled.div<CoverImageProps>`
  ${({ width }) => {
    if (width) {
      return { width: width }
    }
  }}
  ${({ height }) => {
    if (height) {
      return { height: height }
    }
  }}
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(${({src}) => src});
`
